import React from "react";
import "./EventSection.css";
import titleImage from "../assets/4p_event/1.jpg"
import couponImage from "../assets/4p_event/coupon.png"
import descriptionImage from "../assets/4p_event/3.jpg"
import backgroundImage from "../assets/4p_event/background.jpg"

function EventSection() {
  return (
    <section className="event-section">
  <div className="background" style={{ backgroundImage: `url(${backgroundImage})` }}>
  </div>

  <div className="event-title">
    <img src={titleImage} alt="무료 컨설팅 및 체험단 무료 EVENT"/>
  </div>

  <div className="event-coupon">
    <img src={couponImage} alt="가운데 쿠폰 이미지"/>
  </div>

  <div className="event-description">
    <img src={descriptionImage} alt="하단 설명 텍스트 이미지"/>
  </div>
    </section>
  );
}

export default EventSection;
